import DirectionalButton from "../../components/DirectionalButton";

function Director({ content }) {
  return (
    <section className="director-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4 director-statement-column" data-wow="fade-right">
            <p className="director-studio-name">
              <img
                className="star-icon"
                src="/assets/images/star.png"
                alt="star"
                aria-hidden="true"
              />
              {content.studioName}
            </p>
            <h2>{content.statement}</h2>
          </div>

          <div className="col-lg-4" data-wow="zoom">
            <img
              className="director-image img-responsive"
              src={content.image}
              alt={content.imageAlt}
            />
          </div>

          <div className="col-lg-4 director-content-column" data-wow="fade-left">
            <p className="director-role">{content.role}</p>
            <h2>{content.title}</h2>
            {content.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <DirectionalButton href={content.ctaHref}>
              {content.ctaLabel} <i className="fa-solid fa-arrow-right" />
            </DirectionalButton>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Director;
